"use client";

/**
 * 카미봇 메인 페이지 (2026 리뉴얼)
 *
 * 디자인 핸드오프(`Kamibot Homepage - High fidelity.zip`)를 Next.js 16 + React 19로 이식.
 * 디자인/카피/금기 사항은 `.design-handoff/MIGRATION_GUIDE.md` 참조.
 *
 * 컴포넌트 순서: Hero → Features → LiveDemo → LivePulse → WhiteLabel → Steps → Trust → Support → FAQ → Foot
 * 추가: ScrollMascot (스크롤 따라오기 마스코트, 가이드 §2.2)
 *
 * 모든 토큰은 `.kamibot-v2` 컨테이너 안에서만 활성 → 다른 페이지(/dashboard 등)에 영향 없음.
 */

import { useTheme } from "next-themes";
import { useAuth } from "@/contexts/AuthContext";

import { Hero } from "@/components/kamibot-v2/sections/Hero";
import { Features } from "@/components/kamibot-v2/sections/Features";
import { LiveDemo } from "@/components/kamibot-v2/sections/LiveDemo";
import { LivePulse } from "@/components/kamibot-v2/sections/LivePulse";
import { WhiteLabel } from "@/components/kamibot-v2/sections/WhiteLabel";
import { Steps } from "@/components/kamibot-v2/sections/Steps";
import { Trust } from "@/components/kamibot-v2/sections/Trust";
import { Support } from "@/components/kamibot-v2/sections/Support";
import { FAQ } from "@/components/kamibot-v2/sections/FAQ";
import { Foot } from "@/components/kamibot-v2/sections/Foot";
import { ScrollMascot } from "@/components/kamibot-v2/sections/ScrollMascot";

const INVITE_URL = "https://discord.gg/kamibot";

export default function Home() {
  const { user, login } = useAuth();

  // next-themes는 'system'/'light'/'dark' 셋 다 가능. Hero는 'light' | 'dark'만 받으므로 좁힘.
  const { resolvedTheme, setTheme } = useTheme();
  const theme: "light" | "dark" = resolvedTheme === "dark" ? "dark" : "light";

  const handleInvite = () => {
    window.open(INVITE_URL, "_blank", "noopener,noreferrer");
  };

  const handleLogin = () => {
    login();
  };

  return (
    <div className="kamibot-v2">
      <Hero
        theme={theme}
        setTheme={(t) => setTheme(t)}
        user={user}
        onInvite={handleInvite}
        onLogin={handleLogin}
      />
      <Features />
      <LiveDemo />
      <LivePulse />
      <WhiteLabel />
      <Steps />
      <Trust />
      <Support />
      <FAQ />
      <Foot />
      <ScrollMascot enabled />
    </div>
  );
}
